/**
 * Created by csaba.adam on 2016. 12. 05.
 */
export default function (form, field) {
	if (form && field && form[field] && form.hasOwnProperty('$submitted') && form[field].hasOwnProperty('$invalid')) {
		return form[field].$invalid && (form[field].$touched || form.$submitted);
	}
	return false;
};
